import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=ac9aef6c&scoped=true&"
import script from "./Privacy.vue?vue&type=script&lang=ts&"
export * from "./Privacy.vue?vue&type=script&lang=ts&"
import style0 from "./Privacy.vue?vue&type=style&index=0&id=ac9aef6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac9aef6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
